export abstract class InMemoryObjectBase<T>  {

  protected _items: T[];

  constructor() {
    this._items = this._loadItems();
    if (!this._items) {
      this._items = this._createDemoItems();
    }
  }

  static getMaxElementId<Z>(items: Z[], getItemId: (item: Z) => number): number {
    if (!items || items.length === 0) {
      return 1;
    }
    const maxId = Array.from(items).reduce((p, v) => {
      return (getItemId(p) > getItemId(v) ? p : v);
    });

    const id = getItemId(maxId) + 1;
    if (isNaN(id) || id <= 0) {
      return items.length + 1;
    }

    return id;
  }
  protected get storeKeyName(): string {
    return '';
  }

  get items(): T[] {
    return this._items;
  }

  save(): void {
    const items = Array.from(this._items);
    localStorage.setItem(this.storeKeyName, JSON.stringify(items));
  }

  get newItemId(): number {
    return InMemoryObjectBase.getMaxElementId(this.items, this._getItemId);
  }

  protected _getItemId(item: T): number {
    return NaN;
  }

  protected _loadItems(): T[] {
    const items = localStorage.getItem(this.storeKeyName);
    return this._FromJSON(items);
  }

  protected _FromJSON(json: string): T[] {
    return new Array<T>();
  }

  protected _createDemoItems(): T[] {
    return new Array<T>();
  }
}
